import * as videojs from "video.js";


/**
 * Player overlay class.
 */
export class PlayerOverlayPlugin {

    private player: any;
    private domElement: any;
    private textContent: string;

    constructor(player, text: string = 'Mon texte ici') {

        this.player = player;
        this.textContent = text;

        return this;
    }

    private setupDom() {
        const domElement = (videojs as any).dom.createEl('div', {
            className: 'vjs-player-overlay'
        });
        domElement.innerHTML = `<a href=""><span>${this.textContent}</span></a>`;
        this.player.el().appendChild(domElement);
        this.domElement = domElement;
    }

    private initEvents() {
        this.domElement.addEventListener('click', event => this.onClick(event));
    }

    private onClick(event) {
        event.preventDefault();
        if(this.player.isFullScreen) {
            this.player.exitFullscreen();
        }
        setTimeout( _ => this.player.trigger('overlay-click'), 500);
    }

    public show() {
        this.setupDom();
        this.initEvents();
    }

}

const onPlayerReady = (player, options) => {
    player.playerOverlay = new PlayerOverlayPlugin(player, options);
};

const playerOverlay = function (options: any) {
    this.ready(() => {
        onPlayerReady(this, options);
    });
};

export {playerOverlay};